import React, { useEffect } from "react";

import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { Layout, message, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useAuth } from "../../helpers/auth";
import { AUTHENTICATE_WITH_GITHUB_MUTATION } from "../../helpers/graphql/auth";
import { signInPath, rootPath } from "../../helpers/paths";

export function GithubLogin() {
  const navigate = useNavigate();
  const auth = useAuth();
  const [searchParams] = useSearchParams();

  const location = useLocation() as any;
  const from = location.state?.from?.pathname || rootPath();

  const [authenticate, { loading, data }] = useMutation(AUTHENTICATE_WITH_GITHUB_MUTATION, {
    onError() {
      navigate(signInPath(), { replace: true });
    },
  });

  const code = searchParams.get("code");
  const token = data?.authenticateWithGithub.token;

  useEffect(() => {
    authenticate({ variables: { code: code } });
  }, [code, authenticate]);

  useEffect(() => {
    if (token) {
      auth.createSession(token, () => {
        message.success("Login sucessful!");
        navigate(from, { replace: true });
      });
    }
  }, [token, from, auth, navigate]);

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  return (
    <Layout style={{ height: "100vh" }}>
      {loading ? <Spin style={{ marginTop: "50vh" }} indicator={antIcon} /> : null}
    </Layout>
  );
}
